import { render, staticRenderFns } from "./CarouselButton.vue?vue&type=template&id=f884209a&scoped=true&"
import script from "./CarouselButton.vue?vue&type=script&lang=js&"
export * from "./CarouselButton.vue?vue&type=script&lang=js&"
import style0 from "./CarouselButton.vue?vue&type=style&index=0&id=f884209a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f884209a",
  null
  
)

export default component.exports